const routeStates = {
    from: null,
    to: null,
    redirectFrom: null,
    redirectTo: null,
    redirectOverride: null,
};
const getters = {
    hasSavedRoute(state) {
        return state.from && state.to;
    },
    from(state) {
        return state.from;
    },
    to(state) {
        return state.to;
    },
    hasSavedRedirection(state) {
        return state.redirectFrom && state.redirectTo && state.redirectOverride;
    },
    redirectFrom(state) {
        return state.redirectFrom;
    },
    redirectTo(state) {
        return state.redirectTo;
    },
    redirectOverride(state) {
        return state.redirectOverride;
    },
};
const mutations = {
    resetRouteHistory(state) {
        state.from = null;
        state.to = null;
    },
    setRouteHistory(state, payload) {
        state.from = payload.from;
        state.to = payload.to;
    },
    setFrom(state, route) {
        state.from = route;
    },
    setTo(state, route) {
        state.to = route;
    },
    resetRouteRedirection(state) {
        state.redirectFrom = null;
        state.redirectTo = null;
        state.redirectOverride = null;
    },
    setRouteRedirection(state, payload) {
        state.redirectFrom = payload.from;
        state.redirectTo = payload.to;
        state.redirectOverride = payload.override;
    },
    setRedirectFrom(state, route) {
        state.redirectFrom = route;
    },
    setRedirectTo(state, route) {
        state.redirectTo = route;
    },
    setRedirectOverride(state, route) {
        state.redirectTo = route;
    },
};
export default {
    namespaced: true,
    state: routeStates,
    getters,
    mutations,
};
